import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { NewOrderRecipeInput } from './NewOrderRecipeInput';
import { NewOrderRecipeOutput } from './NewOrderRecipeOutput';

export class NewOrderRecipeService extends HttpServiceBase {

  handle = (input: NewOrderRecipeInput): Promise<Result<NewOrderRecipeOutput> | null> => {
    const promise = this.http.post<Result<NewOrderRecipeOutput>, FormData>(`${this.baseUrlFileRepositoryApi}/order-recipe/new`, input.formData, true);
    return promise;
  }
}